"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/builtin/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _SnackbarContent.default;
  }
});

var _SnackbarContent = _interopRequireDefault(require("./SnackbarContent"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/core/SnackbarContent/index.js
 ** module id = 393
 ** module chunks = 0
 **/